export enum UserPropertyEnum {
  BOOLEAN_VALUE = 'booleanValue',
  NUMBER_VALUE = 'numberValue',
  STRING_VALUE = 'stringValue',
  JSON_VALUE = 'jsonValue',
  DEFAULT_WORKSPACE = 'userDefaultWorkspace',
  AUTO_ASSIGNED_DEFAULT_WORKSPACE = 'autoAssignedDefaultWorkspace',
  AUTO_ASSIGNED_DEFAULT_WORKSPACE_NAME = 'autoAssignedDefaultWorkspaceName',
  PROFILE = 'profile',
  PROFILE_URL = 'profileUrl',
  CONSIDER_FOR_WAVEFORM_EXP = 'considerForWaveformExperiment-ab-9-22-21',
  CANVAS_FTUX_MODAL = 'canvasFtuxModal',
}

export const userProperties = {
  [UserPropertyEnum.BOOLEAN_VALUE]: {
    defaultValue: false,
    type: Boolean,
  },
  [UserPropertyEnum.NUMBER_VALUE]: {
    defaultValue: 0,
    type: Number,
  },
  [UserPropertyEnum.STRING_VALUE]: {
    defaultValue: '',
    type: String,
  },
  [UserPropertyEnum.JSON_VALUE]: {
    defaultValue: null,
    type: JSON,
  },
  [UserPropertyEnum.DEFAULT_WORKSPACE]: {
    defaultValue: 0,
    type: Number,
  },
  [UserPropertyEnum.AUTO_ASSIGNED_DEFAULT_WORKSPACE]: {
    defaultValue: 0,
    type: Number,
  },
  [UserPropertyEnum.AUTO_ASSIGNED_DEFAULT_WORKSPACE_NAME]: {
    defaultValue: '',
    type: String,
  },
  [UserPropertyEnum.PROFILE]: {
    defaultValue: {
      v1: {
        role: '',
        location: '',
        introLoom: '',
      },
    },
    type: JSON,
  },
  [UserPropertyEnum.PROFILE_URL]: {
    defaultValue: '',
    type: String,
  },
  [UserPropertyEnum.CONSIDER_FOR_WAVEFORM_EXP]: {
    defaultValue: false,
    type: Boolean,
  },
  [UserPropertyEnum.CANVAS_FTUX_MODAL]: {
    defaultValue: true,
    type: Boolean,
  },
};

type JsonType = {
  something: string;
  somethingElse: number;
  also?: boolean;
};

type ProfileV1JsonType = {
  role?: string;
  location?: string;
  introLoom?: string;
};

type ProfileJsonType = {
  v1: ProfileV1JsonType;
};

export type UserPropertyValueType<T> = T extends UserPropertyEnum.BOOLEAN_VALUE
  ? boolean
  : T extends UserPropertyEnum.NUMBER_VALUE
  ? number
  : T extends UserPropertyEnum.STRING_VALUE
  ? string
  : T extends UserPropertyEnum.JSON_VALUE
  ? JsonType
  : T extends UserPropertyEnum.DEFAULT_WORKSPACE
  ? number
  : T extends UserPropertyEnum.AUTO_ASSIGNED_DEFAULT_WORKSPACE
  ? number
  : T extends UserPropertyEnum.AUTO_ASSIGNED_DEFAULT_WORKSPACE_NAME
  ? number
  : T extends UserPropertyEnum.PROFILE
  ? ProfileJsonType
  : T extends UserPropertyEnum.BOOLEAN_VALUE
  ? boolean
  : unknown;
